export default __webpack_public_path__ + "static/media/holly_win.448f193b.png";